import { Validator } from '@vista-digital/validator';
import { defaultOccSeatingAreaLabelsConfig, occSeatingAreaLabelsConfigValidator } from './area-labels';
import { defaultOccSeatingLegendConfig, occSeatingLegendConfigValidator } from './legend';
import { defaultOccSeatingMapConfig, occSeatingMapConfigValidator } from './map';
import { defaultOccSeatingNavigationConfig, occSeatingNavigationConfigValidator } from './navigation';
import { defaultOccSeatingNotificationConfig, occSeatingNotificationConfigValidator } from './notification';
import { defaultOccSeatingRowLabelsConfig, occSeatingRowLabelsConfigValidator } from './row-labels';
import { defaultOccSeatingScreenConfig, occSeatingScreenConfigValidator } from './screen';
import { defaultOccSeatingSelectionRulesConfig, occSeatingSelectionRulesConfigValidator } from './seat-selection-rules';
import { defaultOccSeatingSeatsConfig, occSeatingSeatsConfigValidator } from './seats';
/**
 * Default configuration options for seating.
 */
export const defaultOccSeatingConfig = {
    screen: defaultOccSeatingScreenConfig,
    seats: defaultOccSeatingSeatsConfig,
    rowLabels: defaultOccSeatingRowLabelsConfig,
    areaLabels: defaultOccSeatingAreaLabelsConfig,
    legend: defaultOccSeatingLegendConfig,
    notification: defaultOccSeatingNotificationConfig,
    navigation: defaultOccSeatingNavigationConfig,
    selectionRules: defaultOccSeatingSelectionRulesConfig,
    map: defaultOccSeatingMapConfig
};
export const occSeatingConfigValidatorSchema = {
    screen: occSeatingScreenConfigValidator,
    seats: occSeatingSeatsConfigValidator,
    rowLabels: occSeatingRowLabelsConfigValidator,
    areaLabels: occSeatingAreaLabelsConfigValidator,
    legend: occSeatingLegendConfigValidator,
    notification: occSeatingNotificationConfigValidator,
    navigation: occSeatingNavigationConfigValidator,
    selectionRules: occSeatingSelectionRulesConfigValidator,
    map: occSeatingMapConfigValidator
};
export const occSeatingConfigValidator = Validator.object(occSeatingConfigValidatorSchema);
export const partialOccSeatingConfigValidatorSchema = {
    screen: Validator.optional(occSeatingScreenConfigValidator),
    seats: Validator.optional(occSeatingSeatsConfigValidator),
    rowLabels: Validator.optional(occSeatingRowLabelsConfigValidator),
    areaLabels: Validator.optional(occSeatingAreaLabelsConfigValidator),
    legend: Validator.optional(occSeatingLegendConfigValidator),
    notification: Validator.optional(occSeatingNotificationConfigValidator),
    navigation: Validator.optional(occSeatingNavigationConfigValidator),
    selectionRules: Validator.optional(occSeatingSelectionRulesConfigValidator)
};
export const partialOccSeatingConfigValidator = Validator.object(partialOccSeatingConfigValidatorSchema);
//# sourceMappingURL=seating.js.map